import ApiDrivenModel from "./ApiDrivenModel";

export default class Profile extends ApiDrivenModel {
	static async GetCurrent(user) {
		if (Profile.Current) {
			return Profile.Current;
		}

		if (!user) {
			return null;
		}

		const result = await Profile.FetchBy({
			filter: [{ property: 'username', value: user.username, }],
		});
		Profile.Current = result;

		return Profile.Current;
	}
	
	// TODO REMOVE? setter was added to help with property setting ... but the getter may not be used anymore
	// set name (val) {}
	// get name() {
	// 	return this.given_name && this.family_name ? `${this.given_name} ${this.family_name}` : undefined;
	// }


	static ENDPOINT = "/Profile";
	static SEARCH_PATHS = {
		id: true,
		email: true,
		family_name: true,
		given_name: true,
		organization: {
			'id': true,
			'name': true,
			'logo': true,
			'icon': true,
			'branding': true,
			parent: {
				'id': true,
				'name': true,
				'logo': true,
				'icon': true,
				'branding': true,
			}
		},
		organization_name: true,
		preferences: true,
	};
	static LOAD_PATHS = {
		id: true,
		email: true,
		family_name: true,
		given_name: true,
		organization: {
			'id': true,
			'name': true,
			'logo': true,
			'icon': true,
			'branding': true,
			parent: {
				'id': true,
				'name': true,
				'logo': true,
				'icon': true,
				'branding': true,
			}
		},
		organization_name: true,
		preferences: true,
	};
}
